import { render, staticRenderFns } from "./proposal-dialog.vue?vue&type=template&id=a2f4f1d8&scoped=true"
import script from "./proposal-dialog.vue?vue&type=script&lang=js"
export * from "./proposal-dialog.vue?vue&type=script&lang=js"
import style0 from "./proposal-dialog.vue?vue&type=style&index=0&id=a2f4f1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4f1d8",
  null
  
)

export default component.exports